import IconsExperiment from './IconsExperiment';
import loadable from '@loadable/component';

const PersonalInfoIconV3 = loadable(() => import('./PersonalInfoIconV3'));

const PersonalInfoIconExperiment = (props) => {
  return <IconsExperiment iconV3={<PersonalInfoIconV3 {...props} />} />;
};

PersonalInfoIconExperiment.displayName = 'PersonalInfoIconExperiment';

export default PersonalInfoIconExperiment;
